import gql from 'graphql-tag'

export const fetchUser = user_id => ({
	query: gql`
		query ($user_id: bigint!) {
			user: users_by_pk(id: $user_id) {
				name
				lastname
				email
				password
				mobile
				phone
				country_id
				rol_id
				office_id
				team_id
				dni
				address
				address_state_id
				address_zipcode
				office: organizations_office {
					delegation: organizations_delegation {
						zone: organizations_zone {
							territory: organizations_territory {
								organization {
									id
								}
							}
						}
						id
					}
				}
			}
		}
	`,
	update: data => ({
		...data.user,
		delegation_id:
			data.user.office && data.user.office.delegation
				? data.user.office.delegation.id
				: null,
		organization_id:
			data.user.office &&
			data.user.office.delegation &&
			data.user.office.delegation.zone &&
			data.user.office.delegation.zone.territory &&
			data.user.office.delegation.zone.territory.organization
				? data.user.office.delegation.zone.territory.organization.id
				: null
	}),
	variables: { user_id },
	skip: user_id == null
})
